import { useQuery } from '@tanstack/react-query';

import { BaseError } from './../../helpers/BaseError';

import { TagModel } from '../../models/tag.model';

// services
import API from '../../services/api';

const getTags = async (): Promise<TagModel[]> => {
    const { data } = await API.getTags();

    return data;
};

export default function useTagsQuery() {
    return useQuery<TagModel[], BaseError>({
        queryKey: ['tags'],
        queryFn: () => getTags(),
    });
}
